module.exports = __webpack_public_path__ + "fonts/TTNormsPro-Bold.3d27a6db.eot";